import { defineMessages } from "@/i18n";
import en from "./en";

export const framesNoteMessages = defineMessages("frames-note", en);
